import React, { Component } from "react";
import { SelectValue, LabeledValue } from "antd/lib/select";
import {Select,Spin} from 'antd'
import CommonUser from '../models/commonUser'
import AppService from "../service/app.service";
import "./style.css";
const { Option } = Select;
interface iProps {
  defaultValue?: CommonUser[];
  value?: CommonUser[];
  allowClear?: boolean;
  placeholder?: string;
  url?: string;
  userType?: string;
  onChange?: (value: CommonUser[]) => void;
  params?:any;
}
interface iState {
  options: CommonUser[];
  fetching: boolean;
}
export default class UserSelect extends Component<iProps, iState> {
  private appService: AppService = new AppService();
  state: iState = {
    options: [],
    fetching: false,
  };
  search = async (searchText = "") => {
    let { url = "", userType = "TEACHER,STUDENT", params = {} } = this.props;
    let options = await this.appService.getCommonUserData({
      url,
      searchText,
      userType,
      params
    });
    this.setState({ options, fetching: false });
  };
  get defaultValue() {
    let { defaultValue = [] } = this.props;
    return defaultValue.map((user: CommonUser) => ({
      value: user.userId,
      label: user.fullName,
      key: JSON.stringify(user),
    }));
  }
  get value() {
    let { value = [] } = this.props;
    return value.map((user: CommonUser) => ({
      value: user.userId,
      label: user.fullName,
      key: JSON.stringify(user),
    }));
  }
  componentDidMount() {
    this.search();
  }
  handleChange = async (selectedItems: LabeledValue[]) => {
    let personList = selectedItems.map(
      (item) => new CommonUser(JSON.parse(item.key))
    );
    this.props.onChange(personList);
    if (selectedItems.length == 0) {
      this.search();
    }
  };
  handleSearch = async (searchText) => {
    await this.setState({ fetching: true });
    this.search(searchText);
  };
  handleBlur=()=>{
    this.search();
  }
  render() {
    const { placeholder = "请选择", allowClear = true } = this.props;
    const { fetching, options } = this.state;
    const filteredOptions = options.filter(
      (o) => !this.value.some((selectedItem) => selectedItem.value == o.userId)
    );
    return (
      <Select
        labelInValue={true}
        defaultValue={this.defaultValue}
        value={this.value}
        allowClear={allowClear}
        onSearch={this.handleSearch}
        onBlur={this.handleBlur}
        mode="multiple"
        dropdownClassName="user-select"
        placeholder={placeholder}
        dropdownMatchSelectWidth={false}
        filterOption={false}
        onChange={this.handleChange}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        style={{ width: "100%" }}
      >
        {filteredOptions.map((item: CommonUser) => (
          <Option label={item.fullName} key={JSON.stringify(item)}>
            {/* <MyIcon type={`icon${item.userType.toLowerCase()}`} /> */}
            {item.fullName}
          </Option>
        ))}
      </Select>
    );
  }
}
